import { Component, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { Scene } from 'src/app/models/Scene';
import { FontService } from 'src/app/services/font.service';

@Component({
  selector: 'app-step-quiz-question-properties',
  templateUrl: './step-quiz-question-properties.component.html',
  styleUrls: ['./step-quiz-question-properties.component.scss'],
})
export class StepQuizQuestionPropertiesComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;
  @Input('questionProperties') questionProperties: any;

  public fontFamilyOptions: any[];
  public fontSizeOptions: number[];
  public ionSelectFontOptions = {
    cssClass: 'select-font quizard-select'
  };

  public selectOptions = {
    cssClass: 'quizard-select'
  };

  constructor(
    public fontService: FontService
  ) {
    this.fontFamilyOptions = this.fontService.fontFamilyOptions;
    this.fontSizeOptions = this.fontService.fontSizeOptions;
  }

  ngOnInit() { }

  setQuestionTextSize(ev) {
    var value = parseFloat(ev.target.value);
    if (value > 30) {
      value = 30;
    }

    if (value < 1) {
      value = 1;
    }

    if (!value) {
      value = 1;
    }


    value = 55 - value;
    this.questionProperties.questionTextSize = parseFloat(value.toFixed(1));
  }

  validateQuestionTextColour() {
    if (this.questionProperties.questionTextColour.trim().length == 0) {
      this.questionProperties.questionTextColour = "#000000";
    }
  }

  setQuestionResponsesTextSize(ev) {
    var value = parseFloat(ev.target.value);
    if (value > 30) {
      value = 30;
    }

    if (value < 1) {
      value = 1;
    }

    if (!value) {
      value = 1;
    }

    value = 55 - value;
    this.questionProperties.questionResponsesTextSize = parseFloat(value.toFixed(1));
  }

  validateQuestionResponsesTextColour() {
    if (this.questionProperties.questionResponsesTextColour.trim().length == 0) {
      this.questionProperties.questionResponsesTextColour = "#000000";
    }
  }
}
